import React, { useEffect, useRef, useState } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  TextField,
  Button,
  Checkbox,
  FormControlLabel,
  IconButton,
  Typography,
  Box,
} from "@mui/material";
import { styled } from '@mui/material/styles';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import DeleteIcon from "@mui/icons-material/Delete";
import styles from '../../component/addCategoryForm/addCategoryForm.module.css';
import { Add, closeCircle, Delete, UploadImg, AddCircle } from '../../Svg';
import styless from '../../component/scheduleComps/scheduleList/partList.module.css';
import NestedUserHeader from "../../component/reusable/NestedUserHeader";
import { useFormik } from "formik";
import * as Yup from 'yup';
import { useDispatch, useSelector } from "react-redux";
import api from "../../utils/api";
import { toast } from "react-toastify";
import Slider from "./Slider";
import PopularProd from "./product/PopularProd";
import Categories from "./Categories";
import axios from "axios";
import { getHeroBannerThunk, heroBannerThunk } from "../../redux/appearanceSlice";
import { getCategoryHeirarchy } from "../../redux/getCategoryHeirarchy";
import FeaturedBrand from "./FeaturedBrand";


const Accordions = styled(Accordion)(({ theme }) => ({
  borderRadius: '8px !important',
  boxShadow: 'none',
  border: `1px solid ${theme.palette.divider}`,
  margin: "20px 0px",
  fontFamily: `'Public Sans', sans-serif`,
  '&::before': {
    background: 'transparent',
    content: 'none',
  },
}));


const HomePage = () => {
  const [expanded, setExpanded] = useState(false);
  const dispatch = useDispatch()

  const [loading, setLoading] = useState('')
  const bannerImageRef = useRef(null);
  const { heroBannerData } = useSelector((state) => state.appearances)

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const isImage = (url) => /\.(jpg|jpeg|png|gif|webp)$/i.test(url);
  const isVideo = (url) => /\.(mp4|mov|avi|webm)$/i.test(url);

  // General Information Formik
  const heroBannerFormic = useFormik({
    initialValues: {
      bannerTitle: heroBannerData?.data?.bannerTitle || '',
      bannerImage: heroBannerData?.data?.assets?.url || '',
    },
    enableReinitialize: true,
    validationSchema: Yup.object({
      bannerTitle: Yup.string().required('bannerTitle is required'),
      bannerImage: Yup.string().required('bannerImage is required'),

    }),
    onSubmit: async (values) => {
      const data = {
        bannerTitle: values.bannerTitle,
        assets: {
          url: values.bannerImage,
          type: isImage(values.bannerImage) ? "IMAGE" : "VIDEO"
        },
        searchBar: true
      }
      // console.log(data);
      dispatch(heroBannerThunk(data));
    },
  });

  const handleImageChange = async (e, attribute, repo) => {

    const file = e.target?.files?.[0] || e.dataTransfer?.files?.[0];
    setLoading('banner')
    try {
      if (file) {

        const body = {
          key: `${Date.now()}_${file.name}`,
          fileType: file.type,
          fileName: file.name,
        };

        const { data, status } = await api.getPutSignedUrl(body);
        console.log(data);

        if (status === 200) {
          await axios.put(data.data?.preSigned, file, {
            headers: {
              "Content-Type": file.type
            }
          })

          heroBannerFormic.setFieldValue(attribute, data?.data?.url)
        }
      }
    } catch (err) {
      console.log(err);
      toast.error("Error uploading file")
    } finally {
      setLoading('')
    }
  };

  const handleRemove = (repo) => {
    heroBannerFormic.setFieldValue(repo, '');
  };

  useEffect(() => {
    dispatch(getHeroBannerThunk())
    dispatch(getCategoryHeirarchy());
  }, [])


  return (
    <>

      <NestedUserHeader
        index="Home Page Builder"
        root="Dashboard"
        buttonText={'Back to list'} />
      <Box sx={{ width: '85%', }}>
        {/* Hero Banner Section */}
        <Accordions sx={{ marginBottom: "20px" }}
          expanded={expanded === "panel1"}
          onChange={handleChange("panel1")}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography sx={{
              fontSize: "16px",
              color: "#1D1F2C",
            }}>Hero Banner</Typography>
          </AccordionSummary>

          <AccordionDetails sx={{ background: '#F0F1F3B2', margin: "0px 20px 20px 20px" }}>
            <form onSubmit={heroBannerFormic.handleSubmit}>
              <label className={styles.addCatLabel} >
                Banner Title
                <input
                  type="text"
                  name="bannerTitle"
                  placeholder="Enter "
                  className={styles.addCatInput}
                  onChange={heroBannerFormic.handleChange}
                  onBlur={heroBannerFormic.handleBlur}
                  value={heroBannerFormic.values.bannerTitle}
                />
                {heroBannerFormic.touched.bannerTitle && heroBannerFormic.errors.bannerTitle && (
                  <div className={styles.errorText}>{heroBannerFormic.errors.bannerTitle}</div>
                )}
              </label>



              <div className={styles.imageUpload}>

                <p className={styles.addCatLabel}>Banner Image</p>
                {loading === 'banner' ? <div className={styles.uploadBox} style={{ background: '#fff', display: 'flex', justifyContent: 'center' }}>
                  please wait...
                </div> :
                  <>
                    {
                      heroBannerFormic.values.bannerImage
                        ?
                        <div className={styles.uploadBox} style={{ background: '#fff', display: 'flex', justifyContent: 'center' }}>
                          {isImage(heroBannerFormic.values.bannerImage) &&
                            <img src={heroBannerFormic.values.bannerImage} alt="" className={styles.previewImage} style={{ width: '100%', objectFit: 'contain' }} />
                          }
                          {isVideo(heroBannerFormic.values.bannerImage) &&
                            <video
                              controls
                              style={{ width: '100%', maxHeight: '500px' }}
                              className={styles.previewImage}
                            >
                              <source src={heroBannerFormic.values.bannerImage} type="video/mp4" />
                            </video>
                          }
                          <div className={styles.cancel_cross} onClick={() => handleRemove("bannerImage")}>
                            {closeCircle()}
                          </div>
                        </div>
                        :
                        <div
                          className={styles.uploadBox}
                          style={{ background: '#fff', cursor: 'pointer' }}
                          onClick={() => bannerImageRef.current.click()}
                          onDrop={(e) => {
                            e.preventDefault();
                            handleImageChange(e, 'bannerImage', 'bannerImage');
                          }}
                          onDragOver={(e) => e.preventDefault()}

                        >
                          <span className={styles.uploadIcon}><UploadImg /></span>
                          <p className={styles.addCatPara}>Drag and drop image here, or click add image</p>

                          <button type="button" className={styles.addImgBtn} >Add Image/video</button>
                          <input
                            type="file"
                            name=""
                            id=""
                            ref={bannerImageRef}
                            style={{ display: 'none' }}
                            onChange={(e) => handleImageChange(e, 'bannerImage', 'bannerImage')}
                            accept="image/*,video/*"
                          />
                        </div>
                    }
                  </>
                }
                {heroBannerFormic.touched.bannerImage && heroBannerFormic.errors.bannerImage && (
                  <div className={styles.errorText}>{heroBannerFormic.errors.bannerImage}</div>
                )}
                <div style={{ margin: "10px 0px 10px 0px", display: 'flex', justifyContent: 'flex-end', gap: '20px' }}>
                  <button className={styless.cancelBtn} onClick={() => heroBannerFormic.resetForm()}>Cancel</button>
                  <button className={styless.submitBtn} type="submit" >{heroBannerFormic.isSubmitting ? 'please wait...' : 'Save changes'}</button>
                </div>

              </div>


            </form>
          </AccordionDetails>
        </Accordions>

        {/* Sliders Section */}
        <Slider
          Accordions={Accordions}
          handleChange={handleChange}
          expanded={expanded}
          isImage={isImage}
          isVideo={isVideo}
        />


        {/* Categories Section */}
        <Categories
          Accordions={Accordions}
          handleChange={handleChange}
          expanded={expanded}
        />

        <FeaturedBrand
          Accordions={Accordions}
          handleChange={handleChange}
          expanded={expanded}
        />



        {/* Product/Manufacturer */}
        <PopularProd
          Accordions={Accordions}
          handleChange={handleChange}
          expanded={expanded}
        />


      </Box>
    </>
  );
};

export default HomePage;
